import { ChevronDownIcon } from '@heroicons/react/24/solid'
import { useState } from 'react'

import { Premise, ProjectSource } from '@/api/models/auth/lib/auth.types'
import { PremiseTypeAlias } from '@/api/models/requests/lib/requests.types'
import { cn } from '@/app/utils'
import { RadioGroupOption } from '@/components/shared/radio-group'

import { ProjectOption } from '../model/project-option'

const ProjectOptionRenderer = (props: RadioGroupOption) => {
  const project = props as ProjectOption
  const [expandedId, setExpandedId] = useState('')

  return (
    <div className="w-full">
      <div className="flex w-full justify-between">
        <div data-project-id={project.key}>{project.name}</div>
        <button
          className="-mr-24 px-24"
          onClick={e => {
            e.stopPropagation()
            setExpandedId(expandedId === project.key ? '' : project.key)
          }}
        >
          <ChevronDownIcon
            className={cn('w-16', {
              '-scale-y-100': expandedId === project.key
            })}
          />
        </button>
      </div>

      {expandedId === project.key && project.src === ProjectSource.SC && (
        <ul className="mt-16 cursor-default space-y-6">
          {project.objects.map((premise: Premise) => (
            <li key={premise.id} className="text-grey-80 text-16">
              {premise.name}
            </li>
          ))}
        </ul>
      )}
      {expandedId === project.key && project.src === ProjectSource.BU && (
        <div className="mt-16 cursor-default">
          {project.personalAccounts
            .flatMap(personalAccount =>
              personalAccount.premises
                .filter(el => el.typeAlias !== PremiseTypeAlias.CarSpace)
                .map(premise => ({
                  personalAccount,
                  premise
                }))
            )
            .map(({ personalAccount, premise }, index, array) => (
              <div
                key={`${personalAccount.id}-${premise.id}`}
                className={cn(
                  'flex gap-16 border-b border-grey-20 py-8',
                  index === array.length - 1 ? 'border-b-0' : ''
                )}
              >
                <div className="w-1/2">
                  <span className="block text-grey-70 text-16">
                    {premise.name}
                  </span>
                </div>
                <div className="w-1/2 text-grey-100 text-16">
                  {personalAccount.name}
                </div>
              </div>
            ))}
        </div>
      )}
    </div>
  )
}

export { ProjectOptionRenderer }
